import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { comics, categories } from '@/mocks/comics';
import { useParams } from 'react-router-dom';

const categoryNames: Record<string, string> = {
  rexue: '热血',
  lianai: '恋爱',
  qihuan: '奇幻',
  wuxia: '武侠',
  dushi: '都市',
  xuanyi: '悬疑',
  zhichang: '职场',
  gaoxiao: '搞笑',
  kongbu: '恐怖',
  yundong: '运动',
};

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();
  const categoryName = categoryNames[slug || ''] || '分类';
  const catInfo = categories.find((c) => c.slug === slug);
  const filteredComics = comics.filter((c) => c.category === categoryName);

  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'CollectionPage',
    name: `${categoryName}漫画 - 韩漫漫画网站`,
    description: `韩漫漫画网站${categoryName}漫画分类，收录${filteredComics.length}+部正版韩国${categoryName}漫画，支持免费在线阅读。`,
    url: `https://www.example.com/category/${slug}`,
    isPartOf: {
      '@type': 'WebSite',
      name: '韩漫漫画网站',
      url: 'https://www.example.com/',
    },
    about: {
      '@type': 'Thing',
      name: `${categoryName}韩国漫画`,
    },
  };

  const breadcrumbLd = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      { '@type': 'ListItem', position: 1, name: '首页', item: 'https://www.example.com/' },
      { '@type': 'ListItem', position: 2, name: '分类浏览', item: 'https://www.example.com/category/rexue' },
      { '@type': 'ListItem', position: 3, name: `${categoryName}漫画` },
    ],
  };

  return (
    <>
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }} />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(breadcrumbLd) }} />

      <Navbar />
      <main className="pt-16">
        <section className="relative bg-gradient-to-br from-primary-800 via-primary-700 to-primary-900 py-16 md:py-24">
          <div className="absolute inset-0 opacity-10">
            <div className="absolute top-10 left-10 w-40 h-40 rounded-full bg-accent-500/30 blur-3xl"></div>
            <div className="absolute bottom-10 right-20 w-60 h-60 rounded-full bg-accent-500/20 blur-3xl"></div>
          </div>
          <div className="relative z-10 w-full px-4 md:px-6">
            <div className="max-w-7xl mx-auto">
              <div className="flex items-center gap-2 text-xs text-accent-300 mb-4">
                <Link to="/" className="hover:text-background-50 transition-colors">首页</Link>
                <i className="ri-arrow-right-s-line"></i>
                <Link to="/category/rexue" className="hover:text-background-50 transition-colors">分类浏览</Link>
                <i className="ri-arrow-right-s-line"></i>
                <span className="text-background-50/70">{categoryName}漫画</span>
              </div>
              <span className="inline-block bg-accent-500/20 border border-accent-400/30 text-accent-200 text-xs font-medium px-3 py-1 rounded-full mb-4">
                {catInfo?.icon && <i className={`${catInfo.icon} mr-1`}></i>}
                {categoryName}分类
              </span>
              <h1 className="font-heading text-3xl md:text-5xl font-extrabold text-background-50 mb-4">
                {categoryName}漫画
              </h1>
              <p className="text-sm md:text-base text-background-200/80 max-w-lg leading-relaxed">
                韩漫漫画网站收录了{catInfo?.count.toLocaleString()}+部正版韩国{categoryName}漫画，每日更新，高清画质，支持免费在线阅读。无论你喜欢哪种风格，这里都有最适合你的{categoryName}故事。
              </p>
            </div>
          </div>
        </section>

        <section className="py-10 md:py-14 bg-background-50">
          <div className="w-full px-4 md:px-6">
            <div className="max-w-7xl mx-auto">
              <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-6">
                {filteredComics.map((comic) => (
                  <Link
                    key={comic.id}
                    to={`/comic/${comic.id}`}
                    className="group bg-background-100 rounded-xl overflow-hidden transition-all duration-300 hover:-translate-y-1 cursor-pointer"
                  >
                    <div className="aspect-[3/4] overflow-hidden">
                      <img
                        src={comic.cover}
                        alt={comic.title}
                        className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                        loading="lazy"
                      />
                    </div>
                    <div className="p-3 md:p-4">
                      <h3 className="font-sans text-sm md:text-base font-semibold text-foreground-900 line-clamp-1 group-hover:text-primary-600 transition-colors">
                        {comic.title}
                      </h3>
                      <p className="text-xs text-foreground-500 mt-1">{comic.author}</p>
                      <div className="flex items-center gap-2 mt-2">
                        <i className="ri-star-fill text-yellow-400 text-xs"></i>
                        <span className="text-xs font-semibold text-foreground-700">{comic.rating}</span>
                        <span className="text-xs text-foreground-400">{comic.views.toLocaleString()} 阅读</span>
                      </div>
                    </div>
                  </Link>
                ))}
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}